/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import {
  upduoPrimaryBlue,
  upduoBlueSummitBackground,
  upduoGraySummitBackground,
  upduoMediumGray,
  upduoSecondaryOrange,
  upduoOrangeSummitBackground,
  upduoSecondaryPurple,
  upduoPurpleSummitBackground,
} from "config/UpduoColors";
import { getSummitColor, SummitColor, SummitState } from "config/Utilities";
import { SummitType } from "graphql/internal/generated";

export function getSummitAccentColor(
  summit: Pick<SummitType, "name">,
  summitState: SummitState
): string {
  if (summitState === SummitState.COMPLETED) {
    return upduoMediumGray;
  }

  const color = getSummitColor(summit);
  switch (color) {
    case SummitColor.BLUE:
      return upduoPrimaryBlue;
    case SummitColor.PURPLE:
      return upduoSecondaryPurple;
    case SummitColor.ORANGE:
      return upduoSecondaryOrange;
  }
}

export function getSummitBackgroundColor(
  summit: Pick<SummitType, "name"> | undefined
): string {
  if (!summit) {
    return upduoGraySummitBackground;
  }

  const color = getSummitColor(summit);
  switch (color) {
    case SummitColor.BLUE:
      return upduoBlueSummitBackground;
    case SummitColor.PURPLE:
      return upduoPurpleSummitBackground;
    case SummitColor.ORANGE:
      return upduoOrangeSummitBackground;
  }
}
